import Content from "../../help/material-import.mdx";

export function MaterialImportHelpPage() {
  return <Content />;
}
